















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CameraPageChangeCameraModeButton extends Vue {
  @Prop({ type: Boolean, default: true })
  public enabled!: boolean;

  private onClick(event: Event): void {
    if (!this.enabled) return;
    this.$emit('click', event);
  }
}
